var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-ver"},[_c('small',[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }